export default {
    lang: {
        name: 'Win Percent'
    }
}